import LoginPassword    from "../../../domain/authentication/LoginPassword";
import Building         from "../../../domain/fundamentals/address/Building";
import City             from "../../../domain/fundamentals/address/City";
import PostalCode       from "../../../domain/fundamentals/address/PostalCode";
import Prefecture       from "../../../domain/fundamentals/address/Prefecture";
import Street           from "../../../domain/fundamentals/address/Street";
import Email            from "../../../domain/fundamentals/email/Email";
import Office           from "../../../domain/office/Office";
import OfficeId         from "../../../domain/office/OfficeId";
import OfficeName       from "../../../domain/office/OfficeName";
import OfficeNameKana   from "../../../domain/office/OfficeNameKana";
import OfficeRepository from "../../../domain/office/OfficeRepository";
import { ApiClient }    from "../../configure/ApiClientConfig";
import {
  setOffice,
  setOfficeAddressBuilding,
  setOfficeAddressCity,
  setOfficeAddressPostalCode,
  setOfficeAddressPrefecture,
  setOfficeAddressStreet,
  setOfficeEmail,
  setOfficeName,
  setOfficeNameKana
}                       from "../../redux/office/OfficeAction";

class OfficeDataSource implements OfficeRepository {
  readonly dispatch;

  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  find() {
    return ApiClient.get("/office");
  }

  findAll() {
    return ApiClient.get("/offices");
  }

  update(office: Office) {
    return ApiClient.put("/office", {
      id: office.id.value,
      name: office.name.value,
      name_kana: office.nameKana.value,
      email_address: office.email.value,
      address: {
        postal_code: office.address.postalCode.value,
        prefecture: office.address.prefecture.value,
        city: office.address.city.value,
        street: office.address.street.value,
        building: office.address.building.value
      }
    })
  }

  changePassword(currentPassword: LoginPassword, newPassword: LoginPassword, confirmPassword: LoginPassword) {
    return ApiClient.put("/office/password", {
      currentPassword: currentPassword.value,
      newPassword: newPassword.value,
      confirmPassword: confirmPassword.value,
    });
  }

  select(officeId: OfficeId) {
    return ApiClient.put("/office/select", {},
      {
        params: {
          officeId: officeId.value
        }
      });
  }

  setOffice(office: Office) {
    this.dispatch(setOffice(office));
  }

  setOfficeAddressBuilding(building: Building) {
    this.dispatch(setOfficeAddressBuilding(building));
  }

  setOfficeAddressCity(city: City) {
    this.dispatch(setOfficeAddressCity(city))
  }

  setOfficeAddressPostalCode(postalCode: PostalCode) {
    this.dispatch(setOfficeAddressPostalCode(postalCode));
  }

  setOfficeAddressPrefecture(prefecture: Prefecture) {
    this.dispatch(setOfficeAddressPrefecture(prefecture));
  }

  setOfficeAddressStreet(street: Street) {
    this.dispatch(setOfficeAddressStreet(street));
  }

  setOfficeEmail(email: Email) {
    this.dispatch(setOfficeEmail(email));
  }

  setOfficeName(name: OfficeName) {
    this.dispatch(setOfficeName(name));
  }

  setOfficeNameKana(nameKana: OfficeNameKana) {
    this.dispatch(setOfficeNameKana(nameKana));
  }

}

export default OfficeDataSource;
